import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActiveSchool } from 'actions/user';
import { Icon, Menu, translate, setActiveLanguage, getActiveLanguage } from '@haldor/ui';

var AppMenu = /*#__PURE__*/function (_Component) {
  _inherits(AppMenu, _Component);

  var _super = _createSuper(AppMenu);

  function AppMenu() {
    var _this;

    _classCallCheck(this, AppMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "switchSchool", function (school, userId) {
      localStorage.setItem('hal.school' + userId, school);

      _this.props.setActiveSchool(school);

      _this.props.history.push('/switch');
    });

    _defineProperty(_assertThisInitialized(_this), "getBadgeForSchool", function (school) {
      if (_this.props.userUnread == null) {
        return null;
      }

      return _this.props.userUnread.reduce(function (value, item) {
        if ((item.schoolId == 0 || item.schoolId == school.id) && item.type == 'CONVERSATION') {
          if (value == null) value = 0;
          return value += item.unread;
        }

        return value;
      }, null);
    });

    _defineProperty(_assertThisInitialized(_this), "getBadgeForItem", function (item) {
      if (_this.props.userUnread == null) {
        return null;
      }

      var activeSchool = _this.props.activeSchool;

      if (item.url == 'select-school') {
        return _this.props.userUnread.reduce(function (value, item) {
          if (item.schoolId == activeSchool || item.type != 'CONVERSATION') {
            return value;
          }

          if (value == null) value = 0;
          return value += item.unread;
        }, null);
      }

      if (item.url == '/conversations') {
        return _this.props.userUnread.reduce(function (value, item) {
          if ((item.schoolId == 0 || item.schoolId == activeSchool) && item.type == 'CONVERSATION') {
            if (value == null) {
              value = 0;
            }

            return value += item.unread;
          }

          return value;
        }, null);
      }

      if (item.url == '/notifications') {
        return _this.props.userUnread.reduce(function (value, item) {
          if ((item.schoolId == 0 || item.schoolId == activeSchool) && item.type == 'NOT') {
            if (value == null) {
              value = 0;
            }

            return value += item.unread;
          }

          return value;
        }, null);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getUserMenu", function () {
      var translate = _this.props.translate;
      var userMenu = [];
      var languages = [{
        lcid: 'sv-se',
        label: translate('swedish')
      }, {
        lcid: 'en-us',
        label: translate('english')
      }, {
        lcid: 'da-dk',
        label: translate('danish')
      }, {
        lcid: 'nb-no',
        label: translate('norwegian')
      }, {
        lcid: 'uk',
        label: translate('ukrainian')
      }];
      languages.forEach(function (language) {
        userMenu.push({
          onClick: function onClick() {
            return _this.switchLanguage(language.lcid);
          },
          label: getActiveLanguage() == language.lcid ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
            name: "check"
          }), " ", language.label) : language.label
        });
      });
      userMenu.push({
        divider: true
      });
      userMenu.push({
        label: translate('log-out'),
        target: '/logout'
      });
      return userMenu;
    });

    return _this;
  }

  _createClass(AppMenu, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "switchLanguage",
    value: function switchLanguage(lang) {
      setActiveLanguage(lang);
      this.props.history.push('/language');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeSchool = _this$props.activeSchool,
          user = _this$props.user,
          translate = _this$props.translate;

      var userSchools = _toConsumableArray(this.props.user.schools);

      var userMenu = this.getUserMenu();
      userSchools = userSchools.sort(function (a, b) {
        return a.title.localeCompare(b.title);
      });
      var categories = [];
      var schools = [];
      var schoolName = '';
      userSchools.forEach(function (school) {
        var badge = _this2.getBadgeForSchool(school) != null ? /*#__PURE__*/React.createElement("span", {
          className: "badge",
          style: {
            display: 'inline-flex',
            justifyContent: 'center',
            transform: 'none',
            borderRadius: '100%',
            position: 'static',
            marginRight: '.4rem'
          }
        }, _this2.getBadgeForSchool(school)) : null;
        var title = /*#__PURE__*/React.createElement("span", null, school.id != activeSchool ? badge : null, school.id == activeSchool ? /*#__PURE__*/React.createElement(Icon, {
          name: "check",
          style: {
            position: 'relative',
            top: 2,
            marginRight: '.4rem'
          }
        }) : null, school.title);

        if (school.id == activeSchool) {
          schoolName = school.title;
        }

        schools.push({
          label: title,
          onClick: function onClick() {
            return _this2.switchSchool(school.id, user.id);
          }
        });
      });

      if (this.props.items != null) {
        this.props.items.forEach(function (item) {
          if (item.parentId != null && item.parentId != '') {
            if (categories.indexOf(item.parentId) == -1) {
              categories.push(item.parentId);
            }
          }
        });
      }

      var items = [];

      if (this.props.items != null) {
        items = _toConsumableArray(this.props.items);
        items.sort(function (a, b) {
          return a.index - b.index;
        });
      }

      return /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement("div", {
        className: "home_school",
        style: {
          flexDirection: 'row',
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement(Menu.Item, {
        label: schoolName,
        Link: Link,
        to: '/',
        icon: /*#__PURE__*/React.createElement(Icon, {
          name: "House"
        }),
        exact: true
      }), /*#__PURE__*/React.createElement(Menu.Item, {
        label: translate('Select-school'),
        icon: /*#__PURE__*/React.createElement(Icon, {
          name: "Chevron_Down"
        }),
        items: schools,
        badge: this.getBadgeForItem({
          url: 'select-school'
        })
      })), this.props.items != null ? this.props.items.map(function (item, index) {
        if (item.parentId != null && item.parentId != '') {
          return null;
        }

        if (item.type == 'EXTERNAL') {
          return null;
        }

        if (item.text === 'NAV_HOME') {
          return null;
        }

        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: 'item-' + index,
          label: translate(item.text.toLowerCase()),
          Link: Link,
          to: item.url,
          icon: /*#__PURE__*/React.createElement(Icon, {
            name: item.iconId
          }),
          badge: _this2.getBadgeForItem(item),
          exact: true
        });
      }) : null, categories.map(function (category) {
        return /*#__PURE__*/React.createElement(Menu.Divider, {
          key: category,
          label: _this2.props.translate(category.toLowerCase())
        }, items.map(function (item, index) {
          if (item.parentId != null && item.parentId == category) {
            return /*#__PURE__*/React.createElement(Menu.Item, {
              key: 'item-' + index,
              label: translate(item.text.toLowerCase()),
              Link: Link,
              to: item.url,
              badge: _this2.getBadgeForItem(item),
              icon: /*#__PURE__*/React.createElement(Icon, {
                name: item.iconId
              }),
              exact: true
            });
          }
        }));
      }), this.props.items != null ? this.props.items.map(function (item, index) {
        if (item.parentId != null && item.parentId != '') {
          return null;
        }

        if (item.type != 'EXTERNAL') {
          return null;
        }

        var label = item.text;

        if (label.indexOf('nav_') > -1) {
          label = translate(item.text.toLowerCase());
        }

        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: 'item-' + index,
          label: label,
          to: item.url,
          icon: /*#__PURE__*/React.createElement(Icon, {
            name: item.iconId
          }),
          target: "_blank",
          exact: true
        });
      }) : null, !this.isIframe() ? /*#__PURE__*/React.createElement(Menu.Item, {
        icon: /*#__PURE__*/React.createElement(Icon, {
          name: "Cog"
        }),
        label: this.props.user.firstName + ' ' + this.props.user.lastName,
        items: userMenu
      }) : null);
    }
  }]);

  return AppMenu;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    user: state.user.currentUser,
    activeSchool: state.user.activeSchool,
    location: document.location.pathname,
    items: state.Menu.items,
    userUnread: state.Notifications.userUnread
  };
}

export default withRouter(connect(mapStateToProps, {
  setActiveSchool: setActiveSchool
})(AppMenu));